'use client'

import type { Page } from '@/payload-types'
import type { ReactNode } from 'react'
import { createContext, useContext } from 'react'

export const PageDataContext = createContext<Page>({
	id: '',
	slug: '',
	template: 'blank',
	title: '',
	updatedAt: '',
	createdAt: '',
})

export const PageDataContextProvider = ({
	children,
	page,
}: {
	children: ReactNode
	page: Page
}) => {
	return <PageDataContext.Provider value={page}>{children}</PageDataContext.Provider>
}

export default PageDataContextProvider

export const usePageData = () => useContext(PageDataContext)
